<template>
  <div class="filters-container" :class="{ 'filters-loading': loading }">
    <FiltersHeader
        :is-collapsed="isCollapsed"
        :has-active-filters="hasActiveFilters"
        :loading="loading"
        :filter-summary="filterSummary"
        @toggle-collapse="toggleCollapse"
        @clear-filters="limparFiltros"
    />

    <div class="filters-card-text">
      <v-expand-transition>
        <div v-show="!isCollapsed" class="filters-content">
          <!-- Carrossel de Filtros usando v-slide-group -->
          <v-slide-group
              v-model="currentSlide"
              class="filters-carousel"
              :show-arrows="true"
              :disabled="loading"
          >
            <!-- Filtro 1: Tipo de Lançamento -->
            <v-slide-item>
              <div class="carousel-item">
                <TipoLancamentoFilter
                    v-model="localFilters.tipoLancamento"
                    :items="tiposLancamento"
                    :loading="loading"
                    @change="emitFilters"
                />
              </div>
            </v-slide-item>

            <!-- Filtro 2: Período -->
            <v-slide-item>
              <div class="carousel-item">
                <DateRangeFilter
                    v-model="localFilters.dateRange"
                    :loading="loading"
                    @change="emitFilters"
                />
              </div>
            </v-slide-item>

            <!-- Filtro 3: Filiais -->
            <v-slide-item>
              <div class="carousel-item">
                <MultiSelectFilter
                    v-model="localFilters.filiais"
                    :items="filiais"
                    item-text="filial"
                    item-value="idfilial"
                    label="Filiais"
                    icon="mdi-office-building"
                    :loading="loading"
                    @change="emitFilters"
                />
              </div>
            </v-slide-item>

            <!-- Filtro 4: Categorias -->
            <v-slide-item>
              <div class="carousel-item">
                <MultiSelectFilter
                    v-model="localFilters.categorias"
                    :items="categorias"
                    item-text="secao"
                    item-value="idsecao"
                    label="Categorias"
                    icon="mdi-shape"
                    :loading="loading"
                    @change="emitFilters"
                />
              </div>
            </v-slide-item>

            <!-- Filtro 5: Marcas -->
            <v-slide-item>
              <div class="carousel-item">
                <MultiSelectFilter
                    v-model="localFilters.marcas"
                    :items="marcas"
                    item-text="fabricante"
                    item-value="idfabricante"
                    label="Marcas"
                    icon="mdi-tag"
                    :loading="loading"
                    @change="emitFilters"
                />
              </div>
            </v-slide-item>
          </v-slide-group>

          <!-- Indicadores de Navegação -->
          <div class="carousel-indicators" v-if="false">
            <v-chip
                v-for="(filter, index) in filters"
                :key="index"
                small
                :color="currentSlide === index ? '#023449' : 'transparent'"
                :text-color="currentSlide === index ? 'white' : '#6b7280'"
                :outlined="currentSlide !== index"
                @click="currentSlide = index"
                class="indicator-chip"
                :disabled="loading"
            >
              <v-icon left x-small :color="currentSlide === index ? 'white' : '#6b7280'">
                {{ filter.icon }}
              </v-icon>
              {{ filter.label }}
            </v-chip>
          </div>
        </div>
      </v-expand-transition>

      <!-- Loading Overlay -->
<!--      <template v-if="!isCollapsed">-->
<!--        <v-overlay :value="loading" absolute opacity="0.3" color="#023449">-->
<!--          <div class="loading-content">-->
<!--            <v-progress-circular indeterminate color="primary" size="64" width="6"></v-progress-circular>-->
<!--            <p class="loading-text">Carregando dados...</p>-->
<!--          </div>-->
<!--        </v-overlay>-->
<!--      </template>-->

      <!-- Filtros Ativos -->
      <ActiveFilters
          v-if="hasActiveFilters"
          :filters="localFilters"
          :loading="loading"
          :tipos-lancamento="tiposLancamento"
          @clear="clearFilter"
      />
    </div>
  </div>
</template>

<script>
import FiltersHeader from './FiltersHeader.vue';
import DateRangeFilter from './DateRangeFilter.vue';
import MultiSelectFilter from './MultiSelectFilter.vue';
import TipoLancamentoFilter from './TipoLancamentoFilter.vue';
import ActiveFilters from './ActiveFilters.vue';

export default {
  name: 'DashboardFilters',

  components: {
    ActiveFilters,
    FiltersHeader,
    DateRangeFilter,
    MultiSelectFilter,
    TipoLancamentoFilter
  },

  props: {
    filiais: { type: Array, default: () => [] },
    categorias: { type: Array, default: () => [] },
    marcas: { type: Array, default: () => [] },
    tiposLancamento: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false }
  },

  data() {
    return {
      isCollapsed: false,
      currentSlide: null,
      localFilters: {
        dateRange: { start: null, end: null },
        filiais: [],
        categorias: [],
        marcas: [],
        tipoLancamento: {
          tipos: [],
          status: null
        }
      },
      filters: [
        { label: 'Período', icon: 'mdi-calendar-range' },
        { label: 'Tipo Lançamento', icon: 'mdi-file-document-outline' },
        { label: 'Filiais', icon: 'mdi-office-building' },
        { label: 'Categorias', icon: 'mdi-shape' },
        { label: 'Marcas', icon: 'mdi-tag' }
      ]
    };
  },

  computed: {
    hasActiveFilters() {
      return this.hasDateRange ||
          this.localFilters.filiais.length > 0 ||
          this.localFilters.categorias.length > 0 ||
          this.localFilters.marcas.length > 0 ||
          this.localFilters.tipoLancamento.tipos.length > 0 ||
          this.localFilters.tipoLancamento.status !== null;
    },

    hasDateRange() {
      return this.localFilters.dateRange.start !== null || this.localFilters.dateRange.end !== null;
    },

    filterSummary() {
      if (!this.hasActiveFilters) return 'Nenhum filtro aplicado';
      if (this.loading) return 'Carregando...';

      const count = [
        this.hasDateRange,
        this.localFilters.filiais.length > 0,
        this.localFilters.categorias.length > 0,
        this.localFilters.marcas.length > 0,
        this.localFilters.tipoLancamento.tipos.length > 0 || this.localFilters.tipoLancamento.status !== null
      ].filter(Boolean).length;

      return `${count} filtro${count > 1 ? 's' : ''} ativo${count > 1 ? 's' : ''}`;
    }
  },

  methods: {
    emitFilters() {
      if (!this.loading) {
        // console.log('Emitting filters:', this.localFilters);
        this.$emit('filter-change', { ...this.localFilters });
      }
    },

    limparFiltros() {
      if (this.loading) return;
      this.localFilters = {
        dateRange: { start: null, end: null },
        filiais: [],
        categorias: [],
        marcas: [],
        tipoLancamento: {
          tipos: [],
          status: null
        }
      };
      this.emitFilters();
    },

    toggleCollapse() {
      if (!this.loading) this.isCollapsed = !this.isCollapsed;
    },

    clearFilter(type) {
      if (this.loading) return;

      if (type === 'dateRange') {
        this.localFilters.dateRange = { start: null, end: null };
      } else if (type === 'tipoLancamento') {
        this.localFilters.tipoLancamento = { tipos: [], status: null };
      } else {
        this.localFilters[type] = [];
      }
      this.emitFilters();
    }
  }
};
</script>

<style scoped>
.filters-container {
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(2, 52, 73, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
}

.filters-container:hover {
  box-shadow: 0 4px 6px rgba(2, 52, 73, 0.1);
}

.filters-container.filters-loading .filters-content {
  pointer-events: none;
  opacity: 0.6;
}

.filters-content {
  padding-top: 12px;
  background: #fafafa;
}

/* Carrossel usando v-slide-group */
.filters-carousel {
  padding-bottom: 20px;
}

.filters-carousel >>> .v-slide-group__prev,
.filters-carousel >>> .v-slide-group__next {
  background: #ffffff !important;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  min-width: 25px !important;
  max-width: 25px !important;
  margin: 0 8px;
  box-shadow: 0 2px 4px rgba(2, 52, 73, 0.08);
  transition: all 0.2s ease;
}

.filters-carousel >>> .v-slide-group__prev:hover:not(.v-slide-group__prev--disabled),
.filters-carousel >>> .v-slide-group__next:hover:not(.v-slide-group__next--disabled) {
  border-color: #023449 !important;
  box-shadow: 0 2px 4px rgba(2, 52, 73, 0.15);
  transform: scale(1.00);
}

.filters-carousel >>> .v-slide-group__prev .v-icon,
.filters-carousel >>> .v-slide-group__next .v-icon {
  color: #023449 !important;
}

.filters-carousel >>> .v-slide-group__prev--disabled,
.filters-carousel >>> .v-slide-group__next--disabled {
  opacity: 0.3;
}

.filters-carousel >>> .v-slide-group__wrapper {
  padding: 2px 0;
}

.filters-carousel >>> .v-slide-group__content {
  gap: 16px;
  padding: 0 4px;
}

.carousel-item {
  width: 350px;
  min-width: 320px;
  max-width: 450px;
  flex-shrink: 0;
}

/* Indicadores */
.carousel-indicators {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  padding: 12px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.indicator-chip {
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 600;
  user-select: none;
}

.indicator-chip:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(2, 52, 73, 0.12);
}

.indicator-chip.v-chip--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 20px;
  background: #ffffff;
  border-radius: 16px;
}

.loading-text {
  color: #023449;
  font-weight: 600;
  font-size: 0.938rem;
  margin: 0;
}

.filters-card-text{
  position: relative;
  //padding-bottom: 24px;
}

/* Responsivo */
@media (max-width: 1600px) {
  .carousel-item {
    width: 320px;
    min-width: 280px;
  }
}

@media (max-width: 1263px) {
  .carousel-item {
    width: 300px;
    min-width: 280px;
  }
}

@media (max-width: 959px) {
  .carousel-item {
    width: 280px;
    min-width: 260px;
  }

  .filters-content {
    padding: 8px 0;
  }

  .carousel-indicators {
    gap: 8px;
  }

  .indicator-chip >>> .v-chip__content {
    padding: 0 8px;
  }
}

@media (max-width: 600px) {
  .carousel-item {
    width: 260px;
    min-width: 240px;
  }

  .filters-carousel >>> .v-slide-group__prev,
  .filters-carousel >>> .v-slide-group__next {
    min-width: 32px !important;
    margin: 0 4px;
  }

  .indicator-chip {
    font-size: 0.7rem;
  }
}

/* Animações */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.carousel-item {
  animation: slideIn 0.3s ease;
}

/* Garante que os filtros não ultrapassem o container */
.carousel-item >>> .filter-group {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  height: 100%;
}
</style>